/**
 * Sale collection discounts on product page + quickview (display only).
 */
(function () {
  function formatMoney(cents) {
    const format = window.theme && (window.theme.moneyFormat || window.theme.moneyWithoutCurrencyFormat);
    if (typeof window.Shopify !== 'undefined' && typeof window.Shopify.formatMoney === 'function' && format) {
      return window.Shopify.formatMoney(cents, format);
    }
    return (cents / 100).toFixed(2);
  }

  function getSalePercent(root) {
    var el = root.querySelector('[data-sale-off]');
    if (!el) {
      return 0;
    }
    return parseInt(el.getAttribute('data-sale-off'), 10) || 0;
  }

  function applySalePrices(root, variant) {
    var discountPercent = getSalePercent(root);
    if (!discountPercent || !variant || !variant.price) {
      return;
    }

    var priceCents = variant.price;
    var salePrice = Math.round(priceCents - (priceCents * discountPercent) / 100);
    var freeText = window.theme && window.theme.strings && window.theme.strings.free ? window.theme.strings.free : 'Free';

    root.querySelectorAll('[data-product-price]').forEach(function (el) {
      el.textContent = priceCents === 0 ? freeText : formatMoney(salePrice);
      el.classList.add('product__price--sale');
    });

    root.querySelectorAll('[data-compare-price]').forEach(function (el) {
      el.textContent = formatMoney(priceCents);
      el.classList.remove('hidden');
    });

    root.querySelectorAll('[data-compare-text]').forEach(function (el) {
      el.classList.remove('hidden');
    });

    root.querySelectorAll('[data-price-off-amount]').forEach(function (el) {
      el.textContent = '-' + discountPercent + '%';
    });

    root.querySelectorAll('[data-price-off-badge], [data-price-off]').forEach(function (el) {
      el.classList.remove('hidden');
    });
  }

  function getProductRoot(target) {
    return (
      target.closest('[data-section-type="product"]') ||
      target.closest('[data-api-content]') ||
      target.closest('.product-quick-add__form')
    );
  }

  function initProductPage() {
    document.querySelectorAll('[data-section-type="product"]').forEach(function (section) {
      var variantInput = section.querySelector('[name="id"]');
      if (!variantInput || !getSalePercent(section)) {
        return;
      }

      var productJson = section.querySelector('[data-product-json]');
      if (!productJson) {
        return;
      }

      try {
        var product = JSON.parse(productJson.textContent);
        var current = product.variants.find(function (v) {
          return String(v.id) === String(variantInput.value);
        });
        if (current) {
          applySalePrices(section, current);
        }
      } catch (e) {}
    });
  }

  document.addEventListener('theme:variant:change', function (e) {
    var root = getProductRoot(e.target);
    if (root && e.detail && e.detail.variant) {
      setTimeout(function () {
        applySalePrices(root, e.detail.variant);
      }, 0);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductPage);
  } else {
    initProductPage();
  }
})();
